import { render } from "./InputSelect.vue?vue&type=template&id=64dcef69&scoped=true&ts=true"
import script from "./InputSelect.vue?vue&type=script&lang=ts"
export * from "./InputSelect.vue?vue&type=script&lang=ts"

import "./InputSelect.vue?vue&type=style&index=0&id=64dcef69&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dcef69"]])

export default __exports__